import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "min-h-screen w-full" }
const _hoisted_2 = { class: "w-full px-4 py-6" }
const _hoisted_3 = { class: "flex flex-col md:flex-row gap-4" }
const _hoisted_4 = { class: "md:w-72 w-full flex-shrink-0 bg-gray-100 rounded-lg shadow-sm border-gray-200 p-4 md:p-5 md:mr-6" }
const _hoisted_5 = { class: "flex justify-between items-center mb-4" }
const _hoisted_6 = { class: "mb-6 md:mb-10" }
const _hoisted_7 = { class: "flex justify-between items-center mb-2" }
const _hoisted_8 = { class: "text-xs text-gray-400 px-2 py-1 border-b mb-2" }
const _hoisted_9 = { class: "h-[28rem] md:h-[40rem] overflow-y-auto overflow-x-auto border border-gray-200 rounded p-2" }
const _hoisted_10 = ["value", "checked", "onChange"]
const _hoisted_11 = {
  key: 0,
  class: "flex items-center justify-center py-3 text-sm bg-gradient-to-r from-gray-50 to-gray-100 rounded-lg border border-gray-200 mx-1"
}
const _hoisted_12 = {
  key: 2,
  class: "text-gray-400 text-xs md:text-sm"
}
const _hoisted_13 = { class: "flex-1 min-w-0" }
const _hoisted_14 = { class: "text-sm text-gray-600 mb-4 px-1" }
const _hoisted_15 = { class: "overflow-x-auto" }
const _hoisted_16 = {
  key: 0,
  class: "mt-4"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_QueryTable = _resolveComponent("QueryTable")!
  const _component_Pagination = _resolveComponent("Pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[9] || (_cache[9] = _createElementVNode("header", { class: "my-10 text-center pb-10" }, [
      _createElementVNode("h1", { class: "text-4xl md:text-5xl align-middle font-semibold text-gray-900" }, " Features Store "),
      _createElementVNode("p", { class: "text-lg md:text-xl text-gray-500" }, "Filter by features")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("aside", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[5] || (_cache[5] = _createElementVNode("h2", { class: "text-base md:text-lg font-semibold text-[#157813]" }, " Filters ", -1)),
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.clearAllFilters && _ctx.clearAllFilters(...args))),
              class: "text-sm text-[#157813] hover:text-[#46cc44] flex items-center gap-1"
            }, [...(_cache[4] || (_cache[4] = [
              _createElementVNode("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                class: "h-4 w-4",
                viewBox: "0 0 20 20",
                fill: "currentColor"
              }, [
                _createElementVNode("path", {
                  "fill-rule": "evenodd",
                  d: "M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z",
                  "clip-rule": "evenodd"
                })
              ], -1),
              _createElementVNode("span", { class: "hidden md:inline" }, "Clear All", -1)
            ]))])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _cache[7] || (_cache[7] = _createElementVNode("h2", { class: "text-base md:text-lg font-semibold text-[#157813]" }, " Features ", -1)),
              _createElementVNode("button", {
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.clearFeatures && _ctx.clearFeatures(...args))),
                class: "text-sm text-[#157813] hover:text-[#46cc44] flex items-center gap-1"
              }, [...(_cache[6] || (_cache[6] = [
                _createElementVNode("svg", {
                  xmlns: "http://www.w3.org/2000/svg",
                  class: "h-3 w-3",
                  viewBox: "0 0 20 20",
                  fill: "currentColor"
                }, [
                  _createElementVNode("path", {
                    "fill-rule": "evenodd",
                    d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
                    "clip-rule": "evenodd"
                  })
                ], -1),
                _createTextVNode(" Clear ", -1)
              ]))])
            ]),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.featureSearch) = $event)),
              type: "text",
              placeholder: "Search features...",
              class: "w-full mb-2 px-2 py-1 border rounded focus:outline-none focus:ring-1 focus:ring-[#157813] text-xs md:text-sm"
            }, null, 512), [
              [_vModelText, _ctx.featureSearch]
            ]),
            _createElementVNode("div", _hoisted_8, " Total: " + _toDisplayString(_ctx.uniqueFeatures.length) + " features (" + _toDisplayString(_ctx.filteredFeatures.length) + " loaded) ", 1),
            _createElementVNode("div", _hoisted_9, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredFeatures, (feature) => {
                return (_openBlock(), _createElementBlock("label", {
                  key: feature,
                  class: "block text-xs md:text-sm mb-2 md:mb-3 whitespace-nowrap"
                }, [
                  _createElementVNode("input", {
                    type: "checkbox",
                    value: feature,
                    checked: _ctx.selectedFeatures.includes(feature),
                    onChange: ($event: any) => (_ctx.toggleFeature(feature)),
                    class: "mr-1",
                    style: {"accent-color":"#157813"}
                  }, null, 40, _hoisted_10),
                  _createTextVNode(" " + _toDisplayString(feature), 1)
                ]))
              }), 128)),
              (_ctx.isFetchingMoreFeatures)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [...(_cache[8] || (_cache[8] = [
                    _createElementVNode("div", { class: "animate-spin rounded-full h-4 w-4 border-2 border-gray-300 border-t-[#157813] mr-3" }, null, -1),
                    _createElementVNode("span", { class: "text-gray-700 font-medium" }, "Loading more features...", -1)
                  ]))]))
                : (_ctx.hasMoreFeatures && _ctx.filteredFeatures.length > 0)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleLoadMoreFeatures && _ctx.handleLoadMoreFeatures(...args))),
                      class: "w-full py-2 text-xs text-[#157813] hover:text-[#46cc44] border border-gray-200 rounded mt-2"
                    }, " Load More Features "))
                  : _createCommentVNode("", true),
              (_ctx.filteredFeatures.length === 0 && !_ctx.isFetchingMoreFeatures)
                ? (_openBlock(), _createElementBlock("p", _hoisted_12, " No matching features "))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createElementVNode("main", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, " Showing " + _toDisplayString(_ctx.displayedQueries.length) + " of " + _toDisplayString(_ctx.filteredQueries.length) + " results ", 1),
          _createElementVNode("div", _hoisted_15, [
            _createVNode(_component_QueryTable, {
              queries: _ctx.displayedQueries,
              headers: _ctx.tableHeaders,
              "sort-state": _ctx.sortState,
              onSort: _ctx.sortBy,
              onRowClick: _ctx.goToDetails,
              onToggleUnique: _ctx.handleToggleUnique
            }, null, 8, ["queries", "headers", "sort-state", "onSort", "onRowClick", "onToggleUnique"])
          ])
        ])
      ])
    ]),
    (_ctx.filteredQueries.length > _ctx.itemsPerPage)
      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
          _createVNode(_component_Pagination, {
            "current-page": _ctx.currentPage,
            "total-items": _ctx.filteredQueries.length,
            "items-per-page": _ctx.itemsPerPage,
            onPageChange: _ctx.handlePageChange
          }, null, 8, ["current-page", "total-items", "items-per-page", "onPageChange"])
        ]))
      : _createCommentVNode("", true)
  ]))
}